export default __webpack_public_path__ + "6dd0ac959b59be3fa948399b4594e897.png";